import { render } from "./UserDetails.vue?vue&type=template&id=e9ea7674"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"
script.render = render

export default script